import { render } from "./applicant.vue?vue&type=template&id=18fdb7b9"
import script from "./applicant.vue?vue&type=script&lang=js"
export * from "./applicant.vue?vue&type=script&lang=js"

import "./applicant.vue?vue&type=style&index=0&id=18fdb7b9&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__